<div [class]="isTile ? 'item-wrapper' : null">
  <vi-item
    #itemRef
    [title]="title"
    [asDropdown]="!!options.length"
    [options]="options"
    [unit]="isCelsius ? Unit.Celsius : Unit.Fahrenheit"
    [value]="value"
    [incorrectValue]="outOfRangeValue"
    (valueChange)="onItemValueChange($event)"
  ></vi-item>
</div>
